import { getGameDeckBuilderConfig } from "@/games";
import MobileCardButtons from "@/components/DeckBuilder/Mobile/CardButtons";
import DesktopCardButtons from "@/components/DeckBuilder/Desktop/CardButtons";
import CardTile from "@/components/Card/CardTile";
import { useClientMediaQuery } from "@/lib/hooks/isMobile";
import { useAddCard, useCurrentGame } from "@/stores/deckStore";
import { orientationOf } from "@/lib/cardArt";

/** Slot dimensions per card size. Both are the portrait card ratio. */
const CARD_SIZES = {
  md: { width: 90, height: 125, buttonSize: "20px", offset: "-10px" },
  lg: { width: 150, height: 209, buttonSize: "28px", offset: "-14px" },
} as const;

export function DeckCardBottom({
  handleOpen,
  aaCardId,
  count,
  cardSize,
  disableClick,
  setHoveredAACardId,
}: {
  handleOpen: any;
  aaCardId: string;
  count: number;
  cardSize: "md" | "lg";
  disableClick: boolean;
  setHoveredAACardId: any;
}) {
  const game = useCurrentGame();
  const addCard = useAddCard();
  const isMobile = useClientMediaQuery("(max-width: 600px)");

  const { width, height, buttonSize, offset } = CARD_SIZES[cardSize];

  const { getAAFromCardId, getCardImage } = getGameDeckBuilderConfig(game);
  const aa = getAAFromCardId(aaCardId);

  // A deck zone holds the same cards the pool does, so a sideways card has to
  // lie down here too rather than being squeezed upright.
  const orientation = orientationOf(game, aaCardId);

  const buttons = isMobile ? (
    <div
      className="absolute -top-0 -right-0 z-40 flex flex-col items-center justify-center"
      style={{ height }}
    >
      <MobileCardButtons handleOpen={handleOpen} aaCardId={aaCardId} />
    </div>
  ) : (
    <div
      className="absolute z-20 flex flex-col"
      style={{ top: offset, right: offset }}
    >
      <DesktopCardButtons
        buttonSize={buttonSize}
        handleOpen={handleOpen}
        aaCardId={aaCardId}
      />
    </div>
  );

  return (
    <CardTile
      src={getCardImage(aa.id, "316x440", aa.src)}
      alt={aa.name}
      orientation={orientation}
      width={width}
      height={height}
      count={count}
      dataId={aaCardId}
      radiusClassName="rounded-[4px]"
      background="bg-neutral-800"
      imgClassName="outline outline-2 outline-offset-[-1px] outline-slate-700 group-hover:outline-white group-hover:shadow-[0_0_10px_rgba(255,255,255,0.4)] transition-[outline-color,box-shadow] duration-150"
      onClick={() => {
        if (!disableClick) {
          addCard(aaCardId, -1);
        }
      }}
      onMouseEnter={() => setHoveredAACardId(aaCardId)}
      onMouseMove={() => setHoveredAACardId(aaCardId)}
      onMouseLeave={() => setHoveredAACardId(null)}
    >
      {buttons}
    </CardTile>
  );
}
